import { headerStyles as styles } from "@bevco/Overrides/Widgets/OrderHistory/OrderHistoryHeader";
import { css } from "styled-components";

styles.toggleFilterGridItem = {
    ...styles.toggleFilterGridItem,
    width: [12, 12, 6, 6, 6],
    align: "middle",
};

styles.invoiceCountGridItem = {
    ...styles.invoiceCountGridItem,
    width: [12, 12, 6, 6, 6],
    align: "middle",
};

styles.toggleFilterButton = {
    ...styles.toggleFilterButton,
    css: css`
        min-width: 250px !important;
    `,
};
